import React, { useEffect, useState } from 'react';
import './HubRegistrations.css';

export default function HubRegistrations() {
  const [registrations, setRegistrations] = useState([]);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/registrations')
      .then((r) => r.json())
      .then((data) => {
        if (data.success) setRegistrations(data.registrations || []);
        else setError(data.message || 'Failed to fetch registrations');
      })
      .catch((err) => {
        console.error('Error fetching registrations:', err);
        setError('Server error fetching registrations');
      })
      .finally(() => setLoading(false));
  }, []);

  async function handleAction(email, firstname, action) {
    try {
      setMessage('');
      const res = await fetch(`/api/${action}/${email}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, firstname }),
      });
      const data = await res.json();
      if (data.success) {
        setMessage(`✅ ${firstname} ${action === 'approve' ? 'approved' : 'rejected'}.`);
        setRegistrations((prev) => prev.filter((r) => r.email !== email));
      } else {
        setMessage(`⚠️ Failed to ${action} ${firstname}.`);
      }
    } catch (err) {
      console.error('Error handling action:', err);
      setMessage(`⚠️ Error: could not ${action} ${firstname}.`);
    }
  }

  return (
    <div className="hubreg-view">
      <h1>New HUB Registrations</h1>

      {message && <div className="hubreg-message">{message}</div>}

      {loading ? (
        <div className="hubreg-loading"><div className="hubreg-spinner" /></div>
      ) : error ? (
        <div className="hubreg-error">{error}</div>
      ) : registrations.length === 0 ? (
        <div className="hubreg-empty">No registrations yet!</div>
      ) : (
        <div className="hubreg-table-wrap">
          <table className="hubreg-table">
            <thead>
              <tr>
                <th>Date</th><th>First</th><th>Last</th><th>Email</th>
                <th>Project</th><th>Role(s)</th><th colSpan={2}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {registrations.map((reg, i) => (
                <tr key={i}>
                  <td>{new Date(reg.date).toLocaleDateString()}</td>
                  <td>{reg.firstname}</td>
                  <td>{reg.lastname}</td>
                  <td>{reg.email}</td>
                  <td>{reg.project}</td>
                  <td>{Array.isArray(reg.roles) ? reg.roles.join(', ') : reg.roles}</td>
                  <td>
                    <button className="hubreg-approve" onClick={() => handleAction(reg.email, reg.firstname, 'approve')}>
                      Approve
                    </button>
                  </td>
                  <td>
                    <button className="hubreg-reject" onClick={() => handleAction(reg.email, reg.firstname, 'reject')}>
                      Reject
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
